import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { copyStaticComponentTemplates } from './copy-static-component-templates.js'

export function copyUiTemplates(cwd: string, config: ResolvedBetterstartConfig): string[] {
  return copyStaticComponentTemplates(cwd, config, 'ui', 'ui')
}
